import {
  initNewSapForThirdParty,
  PolicyType,
} from '@shopee/secure-fetch-utils';

// SAP protection whitelist
// Most of the account business APIs should be protected by SAP
export const SAP_POLICIES: PolicyType[] = [
  {
    match: 'regexp',
    policyurl: /\/api\/v4\/account\/business(?!\/login_status$)/,
    allowCors: true,
  },
];

export const initSap = async () => {
  await initNewSapForThirdParty({
    sapPolicies: SAP_POLICIES,
  });
};
